import { FunctionComponent } from 'react';
import { Tooltip as MaterialTooltip } from '@mui/material';

interface ModalProps {
  toolTipText: any;
  children: JSX.Element;
  blackTooltip?: boolean;
  enterDelay?: number;
  disableInteractive?: boolean;
  followCursor?: boolean;
  placement?: any;
  fullWidth?: boolean;
}

const whiteStyle = {
  maxWidth: '500px',
  background: '#FFFFFF',
  borderTop: '3px solid #5EBBCE',
  fontWeight: 600,
  fontSize: '14px',
  lineHeight: '140%',
  color: '#314157',
  padding: '20px 16px 16px 16px',
  fontFamily: `'Nunito', sans-serif`,
  filter: 'drop-shadow(0px 2px 16px rgba(80, 117, 177, 0.1))',
  boxShadow: '0px 1px 1px rgba(27, 42, 62, 0.05), 0px 3px 8px rgba(27, 42, 62, 0.08)',
  '& .MuiTooltip-arrow': {
    width: '16px',
    height: '16px',
    '&:before': {
      marginTop: '2px',
      width: '13px',
      height: '13px',
      background: '#FFFFFF',
      borderWidth: '0px 0px 3px 3px',
      borderStyle: 'solid',
      borderColor: '#5EBBCE',
      borderRadius: '0px 0px 0px 3px',
      transform: 'rotate(135deg)',
      transformOrigin: 'inherit !important'
    }
  }
};

const blackStyle = {
  background: '#314157',
  borderRadius: '100px',
  fontWeight: 500,
  fontSize: '12px',
  lineHeight: '140%',
  color: '#fff',
  padding: '4px 12px',
  fontFamily: `'Nunito', sans-serif`
};

const Tooltip: FunctionComponent<ModalProps> = ({
  toolTipText,
  children,
  blackTooltip,
  disableInteractive = false,
  enterDelay = 100,
  followCursor = false,
  placement,
  fullWidth = false
}) => {
  return (
    <MaterialTooltip
      disableInteractive={disableInteractive}
      enterDelay={enterDelay}
      title={toolTipText}
      arrow={!blackTooltip}
      placement={placement || 'bottom'}
      enterTouchDelay={0}
      componentsProps={{
        tooltip: {
          sx: blackTooltip ? blackStyle : whiteStyle
        }
      }}
      followCursor={followCursor}
    >
      <div style={{ width: fullWidth ? '100%' : 'auto' }}>{children}</div>
    </MaterialTooltip>
  );
};

export default Tooltip;
